import React, {useState, useEffect} from 'react';
import { Form, Offcanvas, Button, Table } from 'react-bootstrap';
import { DisplaySettingsOutlined, VisibilityOutlined, DeleteForeverOutlined, ModeEditOutlined } from '@mui/icons-material';

import SidebarSubProducts from '../../components/pgi/SidebarSubProducts';



const SubProductosPgi = () => {
    const [showEditSubProduct, setShowEditSubProduct] = useState(true);
    const handleClose = () => setShowEditSubProduct(false);
    const handleShow = () => setShowEditSubProduct(true);
    /* const callBell = document.getElementById('callbell-iframe')
    useEffect(() => {
      callBell && document.getElementById('callbell-iframe').classList.add('d-none')
    }, [callBell]) */

  return (
    <div id='wrapperEditProducts' className='wrapperPgi'>
    <button onClick={handleShow} className="basePgi__setttings-button">
    <DisplaySettingsOutlined/>
    </button>
    

  {/* OFFCANVAS SETTING HOME*/}
  <Offcanvas 
  show={showEditSubProduct} 
  onHide={handleClose} 
  placement='start' 
  scroll 
  enforceFocus 
  backdrop={false} 
  className="basePgi__pgi">
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>EDITAR SUBPRODUCTOS</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <form id='formEditarHSlider' className='basePgi__vista-edit-gral'>
          <header aria-labelledby='formEditarHSlider'>
              <h2>SubProductos</h2><SidebarSubProducts/>
          </header>
          <Table className='basePgi__table-list' hover>
          <colgroup>
                <col span='1' className='basePgi__table-col-position'/>
                <col span='2' className='basePgi__table-col-max'/>
                <col span='3' className='basePgi__table-col-min'/>
          </colgroup>
              <tbody>
                  <tr>
                      <td className='pgi__table-position-number'><b>T21</b></td>
                      <td>#id</td>
                      <td>A1</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button><VisibilityOutlined/></Button></td>
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  {/*************** solo maqueta ************************* 
                   
                  */}
                  <tr>
                      <td className='pgi__table-position-number'><b>T180</b></td>
                      <td>#id</td>
                      <td>B1</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button><VisibilityOutlined/></Button></td>                      
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  <tr>
                      <td className='pgi__table-position-number'><b>T180</b></td>
                      <td>#id</td>
                      <td>B2</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button><VisibilityOutlined/></Button></td>
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  <tr>
                      <td className='pgi__table-position-number'><b>PE</b></td>
                      <td>#id</td>
                      <td>ASTER</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button><VisibilityOutlined/></Button></td>
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  <tr>
                      <td className='pgi__table-position-number'><b>T21</b></td>
                      <td>#id</td>
                      <td>ASTER</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button disabled><VisibilityOutlined/></Button></td>
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  <tr>
                      <td className='pgi__table-position-number'><b>T21</b></td>
                      <td>#id</td>
                      <td>B2</td>
                      <td>{/* acción--> PUBLICA (pintado) o desactiva del front ( propiedad disabled) */}
                      <Button
                      //disabled true si no esta publicado 
                      className='disabled'
                      ><VisibilityOutlined/></Button></td>
                      <td><SidebarSubProducts /></td>
                      <td>{/* acción--> ELIMINA PUBLICACIÓN */}
                        <Button><DeleteForeverOutlined/></Button></td>
                  </tr>
                  {/*************** end solo maqueta ************************* */}
              </tbody>
          </Table>
      </form>
   
      {/****************end lista productos *************************** */}
    </Offcanvas.Body>
  </Offcanvas>
  {/*offC slides */}
  
  </div>
  )
}

export default SubProductosPgi